import * as React from "react";
import PropTypes from "prop-types";
import { Reorder, useDragControls } from "framer-motion";

import Stack from "@mui/material/Stack";
import { FormColorField } from "ui/Form";
import IconButton from "ui/IconButton";

import MinusIcon from "assets/svg/minus.svg";
import DragIcon from "assets/svg/drag.svg";

const GradientRow = ({ name, orderId, index, onChangeOrder }) => {
  const dragControls = useDragControls();

  const onRemoveGradient = () => {
    onChangeOrder(orderId);
  };

  return (
    <Reorder.Item
      value={orderId}
      id={orderId}
      dragListener={false}
      dragControls={dragControls}
      style={{ listStyle: "none" }}
    >
      <Stack direction="row" alignItems="center" gap="6px">
        <div
          style={{ cursor: "grab" }}
          id={`gradient-color-${orderId}`}
          onPointerDown={(e) => dragControls.start(e)}
        >
          <DragIcon width="20px" heigh="20px" />
        </div>
        <FormColorField
          name={`${name}.${orderId}`}
          label={`Color ${index + 1}`}
        />
        <IconButton
          id={`remove-gradient-button-${index}`}
          onClick={onRemoveGradient}
          variant="header"
        >
          <MinusIcon width="20px" />
        </IconButton>
      </Stack>
    </Reorder.Item>
  );
};

GradientRow.propTypes = {
  name: PropTypes.string,
  orderId: PropTypes.number,
  index: PropTypes.number,
  onChangeOrder: PropTypes.func,
};

export default GradientRow;
